import React, { useContext, useEffect, useState } from 'react'
import AccessLogs from '../EPCRView/AccessLogs'
import AccessPopup from '../EPCRView/AccessPopup'
import { useNavigate, useParams } from 'react-router-dom'
import API from '../../../../services/API'
import { GlobalContext } from '../../../../App'
import { LinearProgress, Skeleton, Stack, Typography } from '@mui/material'
import Header from './Header'
import IncidentModule from './IncidentModule'
import DemographicsModule from './DemographicsModule'
import Documents from './Documents'
import UploadPaperPRF from '../UploadPaperPRF'
import BigModal from '../../../../components/Modals/BigModal'

const PaperPCRView = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [record, setRecord] = useState({})
  const navigate = useNavigate()
  const { setToast } = useContext(GlobalContext)
  const [openEdits, setOpenEdits] = useState(false)
  const [edits, setEdits] = useState(null)
  const [accessLogged, setAccessLogged] = useState(false)

  const loadRecord = () => {
    API.get(`/paper-pcr/${id}/${accessLogged}`).then((res) => {
      if (res.status === 200) {
        setRecord(res.data)
        setLoading(false)
      } else if (res.status === 403) {
        navigate('/patient-report-forms')
      } else {
        setToast({
          message: 'Unable to fetch record. Please try again later',
          severity: 'error',
        })
      }
    })
  }

  useEffect(() => {
    if (accessLogged) {
      loadRecord()
    }
  }, [accessLogged])

  return (
    <>
      {!accessLogged ? (
        <Skeleton variant="rounded" width="100%" height={200}>
          <AccessPopup paperPCRID={id} setAccessLogged={setAccessLogged} />
        </Skeleton>
      ) : loading ? (
        <LinearProgress />
      ) : (
        <Stack gap={2}>
          <Header record={record} setOpenEdits={setOpenEdits} />
          <Stack paddingX={1} alignItems="center">
            <Typography variant="caption" color="#c00000">
              The information contained herein is privileged and confidential
              and is protected by UK Data Protection laws, including the Data
              Protection Act 2018, and the Computer Misuse Act 1990.
            </Typography>
            <Typography variant="caption" color="#c00000">
              Any unauthorised access, disclosure, distribution, or use of this
              software is strictly prohibited.
            </Typography>
          </Stack>
          <IncidentModule record={record} />
          <DemographicsModule demographics={record.demographics} />
          <Documents documents={record.documents} />
          <BigModal open={openEdits} onClose={() => setOpenEdits(false)}>
            <UploadPaperPRF
              editMode
              setEditMode={setOpenEdits}
              existingRecord={record}
              loadExistingRecord={loadRecord}
            />
          </BigModal>
        </Stack>
      )}
    </>
  )
}

export default PaperPCRView
